import React, { useState } from "react";
import "./gallery.css";

const Gallery = () => {
  const [popupImage, setPopupImage] = useState(null);

  const openImage = (src) => setPopupImage(src);
  const closePopup = () => setPopupImage(null);


  const images = [];
  for (let i = 1; i <= 49; i++) {
    images.push(`${process.env.PUBLIC_URL}/images/photo${i}.jpeg`);
  }

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">📸 गावाचा विकास – छायाचित्रांतून</h2>

      <div className="gallery-grid">
        {images.map((src, index) => (
          <div className="gallery-card" key={index}>
            <img
              src={src}
              alt={`Gallery ${index + 1}`}
              className="gallery-img"
              onClick={() => openImage(src)}
            />
          </div>
        ))}
      </div>

      {popupImage && (
        <div className="popup-overlay" onClick={closePopup}>
          <span className="close-btn">&times;</span>
          <img src={popupImage} className="popup-image" alt="Preview" />
        </div>
      )}
    </div>
  );
};

export default Gallery;
